import React, { useEffect, useState, useImperativeHandle, useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";

import "./custom.scss";

import "./styles.scss";
import { initialData_in as initialData } from "./TableDataSet";

import update from "immutability-helper";

import Rows from "./DnDTables/DataTable";

const P_TYPE = "in";
const API = "/pcsCreate/retrieveParaInList";

const HeaderTarget = {
    inReceivingSite: "Receiving Site",
    inSendingSite: "Sending Site",
    inSetPoint: "Set Point",
    inTargetRange: "Target Range",
    inAcceptableRange: "Acceptable Range",
};

const InTable = (props, _ref) => {
    const { so, sso, autoResizeTextarea,onOpen,RevCmptCheckList } = props;
    const [Hide, setHide] = useState(false);

    const [TData, setTData] = useState([]);
    const [Header, SetHeader] = useState(HeaderTarget);
    const [temp, setTemp] = useState([]);

    useImperativeHandle(_ref, () => ({
        getTableData: () => {
            return TData;
        },
        loadData: ({ data, header }) => {
            let newVal = [];
            let tmparr;
            let tmp;
            let fidx;
            let cmptTypeList;

            data.forEach((d,subIndex) => {
                tmp = initialData;
                tmparr = [];
                d.forEach((dd,rowIndex) => {
                    Object.keys(dd).forEach((k) => {
                        fidx = tmp.findIndex((i) => i.name === k);
                        if (fidx > -1)
                            tmp = update(tmp, {
                                [fidx]: { $merge: { value: dd[k]} },
                            });
                    });

                    tmparr = [...tmparr, ...[tmp]];
                });

                newVal = [...newVal, [...tmparr]];
            });
            setTData((DATA) => [...newVal]);
            setTemp((DATA) => [...newVal]);

            SetHeader((d) => {
                let newData = {};
                Object.keys(HeaderTarget).forEach((i) => {
                    newData[i] = !!header?.[i] ? header?.[i] : HeaderTarget?.[i];
                });
                return newData;
            });
        },
        preOnData: ({data}) =>{
            setTData(data);
        },
        resetData: () =>{
            setTData(temp);
        },
    }));

    useEffect(() => {
        document.querySelectorAll("textarea").forEach((e) => {
            autoResizeTextarea(e);
        });
    }, [TData]);


    const onOpenWrapper = (vv,uniqueCode) => {
        onOpen(vv,uniqueCode,TData,'IN');
    }
    const HandleHide = () => {
        setHide(!Hide);
    };

    const renderFunc = useMemo(() => {
        try {
            let _sso;
            if (sso > 0) {
                _sso = so[sso];
                let remark = _sso[P_TYPE + "Remark"];
                return (
                    <React.Fragment>
                        <tr>
                            <td colSpan={Object.keys(initialData).length - 2} className="name">
                                <div className={"namename"}>
                                    {_sso?.desc}
                                    {/* <div className={"code"}>{"(" + _sso?.seqCode + ")"}</div> */}
                                </div>
                            </td>
                        </tr>
                        {remark !== "FALSE" && (
                            <tr>
                                <td
                                    colSpan={Object.keys(initialData).length - 2}
                                    className="soremark"
                                >
                                    <div>{remark}</div>
                                </td>
                            </tr>
                        )}
                        {TData[sso - 1].map((v, ii) => {
                            return (
                                <Rows
                                    api={API}
                                    code={_sso.code}
                                    PROCode={_sso.code}
                                    index={ii}
                                    rowData={v}
                                    autoResizeTextarea={autoResizeTextarea}
                                    key={"in" + ii}
                                    onOpen = {onOpenWrapper}
                                    dataIndex={sso}
                                    sheetType={"I"}
                                    RevCmptCheckList={RevCmptCheckList}
                                />
                            );
                        })}
                    </React.Fragment>
                );
            } else {
                const ret = so.map((k, i) => {
                    if (!!!k.code) {
                        return null;
                    }
                    try {
                        let chk = TData[i - 1].filter((v) => {
                            let chk2 = v.find((c) => c.name === "hide");
                            return chk2.value !== "TRUE";
                        });
                        let remark = k[P_TYPE + "Remark"];

                        if (chk.length > 0) {
                            return (
                                <React.Fragment key={i}>
                                    <tr>
                                        <td
                                            colSpan={Object.keys(initialData).length - 2}
                                            className="name"
                                        >
                                            <div className={"namename"}>
                                                {k.desc}
                                                {/* <div className={"code"}>
                                                    {"(" + k.seqCode + ")"}
                                                </div> */}
                                            </div>
                                        </td>
                                    </tr>
                                    {remark !== "FALSE" && (
                                        <tr>
                                            <td
                                                colSpan={Object.keys(initialData).length - 2}
                                                className="soremark"
                                            >
                                                <div>{remark}</div>
                                            </td>
                                        </tr>
                                    )}
                                    {!!TData &&
                                        TData[i - 1].map((v, ii) => {
                                            return (
                                                <Rows
                                                    api={API}
                                                    code={k.code}
                                                    PROCode={k.code}
                                                    index={ii}
                                                    rowData={v}
                                                    autoResizeTextarea={autoResizeTextarea}
                                                    key={"in" + ii}
                                                    onOpen = {onOpenWrapper}
                                                    dataIndex={i}
                                                    sheetType={"I"}
                                                    RevCmptCheckList={RevCmptCheckList}
                                                />
                                            );
                                        })}
                                </React.Fragment>
                            );
                        } else {
                            return null;
                        }
                    } catch (e) {
                        return null;
                    }
                });
                return ret;
            }
        } catch (e) {
            return null;
        }
    }, [TData, so, sso]);

    return (
        <section className="detail">
            <div className={"in_table tbl_box " + (Hide ? "hide" : "")}>
                <h1 className={"title "} onClick={HandleHide}>
                    {P_TYPE.toUpperCase()} <FontAwesomeIcon icon={faAngleUp} />
                </h1>
                <div className={"data_table "}>
                    <table>
                        <colgroup>
                            <col width="2%"></col>
                            <col width="4%"></col>
                            <col width="6%"></col>
                            <col width="5%"></col>
                            <col width="3%"></col>
                            <col width="4%"></col>
                            <col width="7%"></col>
                            <col width="2%"></col>
                            <col width="3%"></col>
                            <col width="2%"></col>
                            <col width="3%"></col>
                            <col width="2%"></col>
                            <col width="3%"></col>
                            <col width="2%"></col>
                            <col width="3%"></col>
                            <col width="4%"></col>
                            <col width="7%"></col>
                            <col width="2%"></col>
                            <col width="3%"></col>
                            <col width="2%"></col>
                            <col width="3%"></col>
                            <col width="2%"></col>
                            <col width="3%"></col>
                            <col width="2%"></col>
                            <col width="3%"></col>
                            <col width="7%"></col>
                        </colgroup>
                        <thead>
                            <tr>
                                <th rowSpan="3"></th>
                                <th rowSpan="3">Parameter Code</th>
                                <th rowSpan="3">Parameter Type</th>
                                <th rowSpan="3">Parameter Description</th>
                                <th rowSpan="3">Unit</th>
                                <th colSpan="10">{Header.inReceivingSite}</th>
                                <th colSpan="10">{Header.inSendingSite}</th>
                                <th rowSpan="3">Reference</th>
                                {/* <th rowSpan="3">Remark</th>
                                <th rowSpan="3">Hide</th> */}
                            </tr>

                            <tr>
                                <th rowSpan="2">Criticality</th>
                                <th rowSpan="2">Set point</th>
                                <th colSpan="4">Target Range</th>
                                <th colSpan="4">Acceptable range</th>
                                <th rowSpan="2">Criticality</th>
                                <th rowSpan="2">{Header.inSetPoint}</th>
                                <th colSpan="4">{Header.inTargetRange}</th>
                                <th colSpan="4">{Header.inAcceptableRange}</th>
                                {/* <th colSpan="4">Acceptable range</th> */}
                            </tr>

                            <tr>
                                <th colSpan="2">Min</th>
                                <th colSpan="2">Max</th>
                                <th colSpan="2">Min</th>
                                <th colSpan="2">Max</th>
                                <th colSpan="2">Min</th>
                                <th colSpan="2">Max</th>
                                <th colSpan="2">Min</th>
                                <th colSpan="2">Max</th>
                                {/* <th colSpan="2">Min</th>
                                <th colSpan="2">Max</th> */}
                            </tr>
                        </thead>
                        <tbody>{renderFunc}</tbody>
                    </table>
                </div>
            </div>
        </section>
    );
};

export default React.memo(React.forwardRef(InTable));
